/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Status_CompleteInputs */

const en_work_order_publish_status_complete = /** @type {(inputs: Work_Order_Publish_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing Workflow Complete`)
};

const fr_work_order_publish_status_complete = /** @type {(inputs: Work_Order_Publish_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flux de publication terminé`)
};

const de_work_order_publish_status_complete = /** @type {(inputs: Work_Order_Publish_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichungs-Workflow abgeschlossen`)
};

const it_work_order_publish_status_complete = /** @type {(inputs: Work_Order_Publish_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flusso di lavoro di pubblicazione completato`)
};

const ru_work_order_publish_status_complete = /** @type {(inputs: Work_Order_Publish_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Процесс публикации завершен.`)
};

const es_work_order_publish_status_complete = /** @type {(inputs: Work_Order_Publish_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flujo de trabajo de publicación completo`)
};

const zh_cn2_work_order_publish_status_complete = /** @type {(inputs: Work_Order_Publish_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布工作流程已完成`)
};

const ja_work_order_publish_status_complete = /** @type {(inputs: Work_Order_Publish_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開ワークフローの完了`)
};

const hi_work_order_publish_status_complete = /** @type {(inputs: Work_Order_Publish_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकाशन कार्यप्रवाह पूर्ण`)
};

const pt_pt2_work_order_publish_status_complete = /** @type {(inputs: Work_Order_Publish_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluxo de trabalho de publicação concluído`)
};

/**
* | output |
* | --- |
* | "Publishing Workflow Complete" |
*
* @param {Work_Order_Publish_Status_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_status_complete = /** @type {((inputs?: Work_Order_Publish_Status_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Status_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_status_complete(inputs)
	if (locale === "de") return de_work_order_publish_status_complete(inputs)
	if (locale === "it") return it_work_order_publish_status_complete(inputs)
	if (locale === "ru") return ru_work_order_publish_status_complete(inputs)
	if (locale === "es") return es_work_order_publish_status_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_status_complete(inputs)
	if (locale === "ja") return ja_work_order_publish_status_complete(inputs)
	if (locale === "hi") return hi_work_order_publish_status_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_status_complete(inputs)
	return en_work_order_publish_status_complete(inputs)
});